import {math} from "@game/coregame/helpers";
import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {Vector2} from "@game/coregame/interfaces/Vector2";
import {FighterGroup} from "@game/coregame/view/FighterGroup";
import {Building} from "../entities/Building";
import {Fighter} from "../entities/Fighter";

/**
 * not real ecs system actually, but moved from Unity
 */
export class FighterGroupsSystem {
    private static _groups: (FighterGroup | null)[] = new Array(100).fill(null);
    static _lastIndex: int = -1;

    public static GetActiveGroups(): FighterGroup[] {
        return FighterGroupsSystem._groups.filter(g => g !== null) as FighterGroup[];
    }

    public static CreateNewGroup(
        path: Vector2[],
        speed: float,
        owner: PlayerType,
        target: Building,
        source: Building
    ): int {
        FighterGroupsSystem._lastIndex = math.repeat(FighterGroupsSystem._lastIndex + 1, 100);
        FighterGroupsSystem._groups[FighterGroupsSystem._lastIndex] = new FighterGroup(
            FighterGroupsSystem._lastIndex,
            path,
            speed,
            owner,
            target,
            source
        );

        FighterGroupsSystem.GetActiveGroups().forEach(g => g?.Check());

        return FighterGroupsSystem._lastIndex;
    }

    public static AddFighterToGroup(group: int, fighter: Fighter) {
        FighterGroupsSystem._groups[group]?.AddFighter(fighter);
    }

    public static RemoveGroup(id: int) {
        FighterGroupsSystem._groups[id] = null;
    }

    public static Clear() {
        FighterGroupsSystem._groups.fill(null);
    }
}
